module.exports = __webpack_public_path__ + "img/HXHJ.6221531a.png";